import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';

const REVIEWS = [
  {
    name: 'Tino Ngwenya',
    text: 'The team at Urgent Service Logistics are extremely professional and punctual. I used the man with a van service to move some furniture. Would definitely recommend.',
  },
  {
    name: 'Ella Francis',
    text: "Couldn't recommend Urgent Service Logistics more. On time, reliable, went above and beyond with the house move I recently went through. Fantastic customer service — 5* all round!",
  },
  {
    name: 'Kianna Bruce-Thorn',
    text: 'I had a great experience using this man with a van company for my house move. He was professional, reliable and really helpful throughout the whole process. Everything was handled with care.',
  },
  {
    name: 'Hannah Farmhouse',
    text: 'Great service.',
  },
  {
    name: 'Selling Everythang',
    text: 'Wow wow wow — what an experience! This company went above and beyond. I could not have done the move without them. Thanks again team!',
  },
  {
    name: 'Kai Kavaz',
    text: 'Great service! Helped me move everything out of my garage and also took some unwanted items to the tip. Really helpful, efficient and professional throughout. Stress-free and would definitely recommend!',
  },
  {
    name: 'Yolanda M',
    text: 'Great company! Very professional and friendly.',
  },
  {
    name: 'Taylor Lelliott',
    text: 'Amazing service! Highly recommend.',
  },
  {
    name: 'George Murage',
    text: 'Top service. Communication was good and made everything else easy.',
  },
  {
    name: 'Walter Kusemwa',
    text: 'Great delivery service from USL. Quick delivery, on time, friendly face whenever they deliver, and goods always undamaged.',
  },
  {
    name: 'Subha Ghosh',
    text: 'Brilliant service from start to finish. They helped me transport a bed to another address and made the whole process really easy. Punctual, friendly, careful with the bed, and handled everything professionally.',
  },
  {
    name: 'Sam Ndlovu',
    text: 'Such a great seamless experience. The team were really professional with everything from initial communication to handling the move with care. I would recommend them every day of the week.',
  },
  {
    name: 'Ryan Chimombe',
    text: "Great communication and quality service. In the space of a few hours the van was loaded up and on the road to Liverpool. I couldn't commend them more if I tried.",
  },
];

const Stars = () => (
  <div style={{ display: 'flex', gap: '2px', marginBottom: '0.75rem' }}>
    {[...Array(5)].map((_, i) => (
      <Star key={i} size={16} fill="#fbbf24" color="#fbbf24" />
    ))}
  </div>
);

const Testimonials = () => {
  const trackRef = useRef(null);

  return (
    <section style={{ background: '#f8fafc', padding: '5rem 0', overflow: 'hidden' }}>
      <div style={{ textAlign: 'center', marginBottom: '3rem', padding: '0 5%' }}>
        <h2
          style={{
            fontSize: '2.5rem',
            fontWeight: 900,
            color: '#1a1a1a',
            marginBottom: '1rem',
            textTransform: 'uppercase',
          }}
        >
          What Our Customers Say
        </h2>
        <p style={{ fontSize: '1.15rem', color: '#555', maxWidth: '600px', margin: '0 auto' }}>
          Verified Google Reviews from happy customers across Hampshire
        </p>
      </div>

      <div style={{ position: 'relative' }}>
        <motion.div
          ref={trackRef}
          style={{
            display: 'flex',
            gap: '1.5rem',
            padding: '0 5%',
            cursor: 'grab',
          }}
          animate={{ x: ['0%', '-50%'] }}
          transition={{
            duration: 60,
            ease: 'linear',
            repeat: Infinity,
            repeatType: 'loop',
          }}
          whileHover={{ animationPlayState: 'paused' }}
        >
          {[...REVIEWS, ...REVIEWS].map((review, i) => (
            <div
              key={i}
              style={{
                flex: '0 0 340px',
                background: 'white',
                borderRadius: '16px',
                padding: '1.75rem',
                boxShadow: '0 4px 20px rgba(0,0,0,0.06)',
                border: '1px solid #e2e8f0',
                display: 'flex',
                flexDirection: 'column',
              }}
            >
              <Stars />
              <p
                style={{
                  color: '#333',
                  fontSize: '0.95rem',
                  lineHeight: 1.6,
                  flex: 1,
                  marginBottom: '1rem',
                }}
              >
                {review.text}
              </p>
              <p
                style={{
                  fontWeight: 700,
                  color: '#001F3D',
                  fontSize: '0.9rem',
                  margin: 0,
                }}
              >
                {review.name}
              </p>
              <p style={{ fontSize: '0.75rem', color: '#94a3b8', margin: '2px 0 0' }}>
                Verified Google Review
              </p>
            </div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};

export default Testimonials;
